import React from 'react';
import { Badge } from '../components/ui/badge';

export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const getStatusBadge = (status, expiryDate) => {
  // Check if expired
  if (expiryDate && new Date(expiryDate) < new Date()) {
    return <Badge variant="destructive">Expired</Badge>;
  }

  switch (status) {
    case 'active':
      return <Badge className="bg-green-100 text-green-800">Active</Badge>;
    case 'exhausted':
      return <Badge variant="secondary">Exhausted</Badge>;
    case 'cancelled':
      return <Badge variant="destructive">Cancelled</Badge>;
    case 'closed':
      return <Badge className="bg-gray-100 text-gray-600">Closed</Badge>;
    default:
      return <Badge variant="outline">{status}</Badge>;
  }
};

export const getUtilizationColor = (pct) => {
  if (pct >= 95) return { bar: 'bg-red-500', text: 'text-red-700', bg: 'bg-red-50' };
  if (pct >= 80) return { bar: 'bg-amber-500', text: 'text-amber-700', bg: 'bg-amber-50' };
  return { bar: 'bg-lime', text: 'text-muted-foreground', bg: '' };
};
